import transactionClientService from "../../../services/http/transactions/transactionClient.service";
import { transactionClientActionTypes } from "../../actionTypes/transactions/transactionClient.actionTypes";

export const addTransactionClient = (companyId, data) => async (dispatch) => {
  let response;
  dispatch({ type: transactionClientActionTypes.START_ADD_TRANSACTION_CLIENT });
  try {
    response = await transactionClientService.addTransactionClient(companyId, data);

    dispatch({
      type: transactionClientActionTypes.ADD_TRANSACTION_CLIENT_SUCCESS,
      payload: response.data.payload, // assuming `response.data` contains the charge point info
    });
  } catch (error) {
    response = error?.response;
    dispatch({
      type: transactionClientActionTypes.ADD_TRANSACTION_CLIENT_FAILURE,
      payload: error.message || "Failed to add transaction client.",
    });
  }
  return response?.data;
};

export const getIdAndValidateByPhoneNumber = (companyId, data) => async (dispatch) => {
  let response;
  dispatch({ type: transactionClientActionTypes.START_GET_AND_VALIDATE_CLIENT_CLIENT });
  try {
    response = await transactionClientService.getIdAndValidateByPhoneNumber(companyId, data);

    dispatch({
      type: transactionClientActionTypes.GET_AND_VALIDATE_CLIENT_CLIENT_SUCCESS,
      payload: response.data.payload, // assuming `response.data` contains the charge point info
    });
  } catch (error) {
    response = error?.response;
    dispatch({
      type: transactionClientActionTypes.GET_AND_VALIDATE_CLIENT_CLIENT_FAILURE,
      payload: error.message || "Failed to add transaction client.",
    });
  }
  return response?.data;
};

export const resendClientAccessCode = (companyId, clientId) => async (dispatch) => {
  let response;
  dispatch({ type: transactionClientActionTypes.START_RESEND_ACCESS_CODE });
  try {
    response = await transactionClientService.resendClientAccessCode(companyId, clientId);
    dispatch({ type: transactionClientActionTypes.RESEND_ACCESS_CODE_SUCCESS });
  } catch (error) {
    response = error?.response;
    dispatch({
      type: transactionClientActionTypes.RESEND_ACCESS_CODE_FAILURE,
      payload: error.message || "Failed to resend client access code.",
    });
  }
  return response?.data;
};

export const validateTransactionClientAccessCode = (clientId, accessCode) => async (dispatch) => {
  let response;
  dispatch({ type: transactionClientActionTypes.START_VALIDATE_CLIENT_ACCESS_CODE });
  try {
    response = await transactionClientService.validateTransactionClientAccessCode(clientId, accessCode);
    dispatch({ type: transactionClientActionTypes.VALIDATE_CLIENT_ACCESS_CODE_SUCCESS });
  } catch (error) {
    response = error?.response;
    dispatch({
      type: transactionClientActionTypes.VALIDATE_CLIENT_ACCESS_CODE_FAILURE,
      payload: error.message || "Failed to validate client access code.",
    });
  }
  return response?.data;
};

export const transactionClientActions = {
  addTransactionClient,
  getIdAndValidateByPhoneNumber,
  resendClientAccessCode,
  validateTransactionClientAccessCode,
};
